import { len, pricing } from '@/constants/state'

const isModelAsFrame = (item: ModelNameType) => {
  return item.value.includes('frame')
}

export const calculatePricing = (variant: ConfigurationType): number => {
  const { model, lensOptions } = variant
  let additionFee = 0
  if (Array.isArray(lensOptions)) {
    lensOptions?.forEach((option) => {
      additionFee += len.lenOptions[option].additionFee
    })
  }
  if (!model)
    return additionFee
  return isModelAsFrame(model) ? pricing.model.frame + additionFee : pricing.model.rimless + additionFee
}

export const parseJson = (jsonStr: string) => {
  try {
    return JSON.parse(jsonStr)
  }
  catch (e) {
    return null
  }
}
